export const appConfigLocal = {
    // VZNLYTICS_ENDPOINT: "https://analytics.blueticks.co",
    VZNLYTICS_ENDPOINT: "http://localhost:3030",

    // Plan 5a wire validation — extension shares STAGING MQTT with the local
    // pod so both engines publish presence on the same broker (required for
    // engineId-targeted RPC). Was wss://mqtt.blueticks.co (prod) by default.
    MQTT_BROKER_URL: "wss://stg-mqtt.blueticks.co:443/mqtt",

    // LOCAL DEV (has /drips). Do NOT commit — committed default is stg-api.
    API_ENDPOINT: "http://localhost:3310",
    NOTIFIER_ENDPOINT: "http://localhost:3310",
    APP_ENDPOINT: "http://localhost:3010",

    // Local-backend overrides (uncomment for E2E iteration):
    // API_ENDPOINT: "http://localhost:3310",
    // NOTIFIER_ENDPOINT: "http://localhost:3310",
    // APP_ENDPOINT: "http://localhost:3010",
    DOCS_ENDPOINT: "http://localhost:3025",

    // API_ENDPOINT: "https://api.blueticks.co",
    // NOTIFIER_ENDPOINT: "https://notify.blueticks.co",
    // APP_ENDPOINT: "https://app.blueticks.co",


    CLARITY_ID: '',
    // GA_ID: 'G-2YQ649PE93',
    // GTM_ID: 'GTM-P5TZZS2V',

    /** comment out this 3 for tudoboard */
    // asset_key: 'tudoboard',
    // pricingOptions: 'only-tasks',
    // google_client_id: '171213536785-40uq3jeidmqcuabjsous4deaj8t99870.apps.googleusercontent.com',
    /** ---------------- */


    // API_ENDPOINT: "https://api.blueticks.co",
    // APP_ENDPOINT: "https://app.blueticks.co",

    /** comment out this 3 for blueticks */
    asset_key: 'blueticks',
    pricingOptions: 'extension',
    retrySendMessageTimeoutMinutes: 1,
};
export default appConfigLocal;